<template>
  <div id="threePage">
    <!-- 当前委托查询 -->
    <div class="transcc_new_NewFooter_tabs_mid">
      <div class="transcc_search">
        <!-- <div class="itemSearch">
          <span class="title">商品代码</span>
          <el-select
            v-model="search.commodityCode"
            class="searchSelect"
            size="small"
            filterable
            placeholder="显示全部"
            @change="changeCode"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.commodityCode"
              :value="item.commodityCode"
            >
            </el-option>
          </el-select>
        </div> -->
        <div class="itemSearch">
          <span class="title">商品名称</span>
          <el-select
            :popper-append-to-body="true"
            v-model="search.symbol"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
            @change="changeSymbol"
          >
            <el-option
              v-for="item in commodityOptions"
              :key="item.symbolCode"
              :label="item.symbol"
              :value="item.symbol"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">买 | 卖</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.bsFlag"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in bsFlagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch">
          <span class="title decTitle">状态</span>
          <el-select
           :popper-append-to-body="true"
            v-model="search.status"
            class="searchSelect"
            popper-class="_wtCjStyle"
            size="small"
            placeholder="显示全部"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="itemSearch actionSearch">
          <el-button
            plain
            class="errorBtn"
            size="small"
            style="width: 74px;height: 24px;color:#0486fe;background: #D94066;font-size:14px;"
            @click="searchData"
          >查询</el-button>
          <el-button
            class="greenBtn"
            size="small"
            style="width: 74px;height: 24px;color:#fff;background: #41B37D;font-size:14px;"
            @click="restData"
          >重置</el-button>
        </div>
        <!-- <div class="itemSearch">
          <span class="title miTitle">只显示止盈止损单</span>
          <el-switch
            v-model="value"
            class="searchSelect"
            active-color="#0486FE"
            inactive-color="#D9D9D9"
          >
          </el-switch>
        </div> -->
      </div>
    </div>
    <div class="transcc_new_NewFooter_tabs_tabBox">
      <!-- <div class="transcc_new_NewFooter_tabs_tabBox_head"> -->
      <el-table
        class="table_style"
        ref="table"
        :cell-style="{'text-align':'center'}"
        :key="1"
        :data="tableData"
        height="256"
        row-class-name="rowColor"
        style="width: 100%"
        :cell-class-name="directionClass"
        show-summary
        :summary-method="getSummaries"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 20px auto 0px; width: 100px; height: 100px;"><img src="../../../assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <el-table-column type="selection" width="80" :selectable="selectable" align="center"></el-table-column>
        <!-- <el-table-column
          type="index"
          label="选择"
          width="80"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.checked"
            >
            </el-checkbox>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="orderId"
          label="委托单号"
          align="center"
          min-width="70"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="commodityCode"
          label="商品代码"
          width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买 | 卖"
          sortable="custom"
          min-width="80"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span :class="scope.row.bsFlag=='B'?'red-row':'green-row'"> {{ scope.row.bsFlag=='B'?'买入':'卖出' }}</span>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="singlePrice"
          label="委托价格"
          sortable="custom"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ Number(scope.row.singlePrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderType" label="订立 | 转让" min-width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderType|tradeTypeFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="initQuantity"
          label="委托数量"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.initQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="availableQuantity"
          label="已成交数量"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ util.floatSub(scope.row.initQuantity, scope.row.quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="未成交数量"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatus"
          label="状态"
          min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.orderStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="委托时间"
          min-width="165"
          align="center"
        >

        </el-table-column>
        <!-- <el-table-column
          prop="cancelDealTime"
          label="撤单时间"
          width="165"
        >
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24">
          <el-pagination
            class="pagination_style"
            popper-class="dark_popStyle"
            :current-page="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      class="newPopup"
      :visible.sync="dialogVisible"
    >
      <span>您确定要撤单吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="surexBtn" type="primary" @click="revokeConfirm">确认</el-button>
        <el-button class="canclexBtn" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 批量撤单 -->
    <el-dialog
      title="快捷撤单"
      :visible.sync="dialogVisible1"
      width="30%"
    >
      <span>您确定要撤单吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary" :disabled="fastClickNum>0" @click="fastCloseClick">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol */
import {
  mapGetters
} from 'vuex'
export default {
  props: {
    isCancle: {
      type: Boolean,
      default: false
    },
    isCorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      selected: 'A',
      checked: false,
      inactiveIcon: require('./img/checkDan.png'),
      activeIcon: require('./img/checkDan.png'),
      tableData: [
      //   {
      //   bsFlag: 'B',
      //   commodityCode: 'YH2210',
      //   commodityId: 243,
      //   commodityName: '红皮洋葱2210',
      //   createTime: 1639487653000,
      //   firmId: 5852,
      //   frozeFee: 12.01,
      //   frozeMargin: 800.6,
      //   holdDetailId: null,
      //   minPriceChange: 1,
      //   ocFlag: 'O',
      //   orderId: 931872,
      //   orderStatus: 1,
      //   orderType: 1,
      //   priceScale: 0,
      //   initQuantity: 1,
      //   singlePrice: 4003,
      //   tradeDay: 20211214,
      //   quantity: 1,
      //   unitNumeral: 1,
      //   updateTime: 1639487653000,
      //   updateTimeMs: 1639487653889
      // }
      ],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 6,
        currentPage: 1
      },
      bsFlagOptions: [{
        value: 'A',
        label: '全部'
      },
      {
        value: 'B',
        label: '买入'
      }, {
        value: 'S',
        label: '卖出'
      }],
      search: {
        commodityCode: null,
        symbol: '全部',
        bsFlag: 'A',
        status: null,
        floatPl: null,
        commodityId: null
      },
      value: false,
      statusOptions: [
        {
          value: null,
          label: '全部'
        },
        {
          value: '1',
          label: '已委托'
        },
        {
          value: '4',
          label: '部分成交'
        }
        // {
        //   value: '2',
        //   label: '已成交'
        // },
        // {
        //   value: '3',
        //   label: '已撤单'
        // },
        // {
        //   value: '5',
        //   label: '部分成交后撤单'
        // }
        // {
        //   value: '6',
        //   label: '止盈'
        // },
        // {
        //   value: '7',
        //   label: '止损'
        // }
      ],
      multipleSelection: [],
      fastClickNum: 0,
      fastClickSuccessNum: 0,
      fastClickErrorNum: 0,
      isNetWrong: false,
      OrderFrontSum: {
        'initQuantity': 0,
        'availableQuantity': 0,
        'quantity': 0
      },
      sOrderId: null,
      showStatus: false
    }
  },
  updated() {
      this.$nextTick(() => {
          this.$refs.table.doLayout()
      })
  },
  computed: {
    ...mapGetters(['h_orderTime', 'sessionInfoGetter', 'commodityStrategyGetter', 'marketStatusGetter']),
    commodityOptions() {
        const commodityList = structuredClone(this.$store.state.hqData.marketDetails)
      commodityList.unshift({commodityId: null,symbol: '全部'})
      // return this.$store.state.hqData.marketDetails
      return commodityList
    },
    fastDisabled() {
      if (this.multipleSelection.length > 0) {
        return false
      }
      return true
    }
  },
  watch: {
    h_orderTime(val, oldVal) {
      if (val != oldVal && !this.showStatus) {
        var that = this
        setTimeout(() => {
          that.showData()
        })
      }
    },
    isCancle(val) {
      if (val) {
        if (this.multipleSelection.length) {
          if (this.multipleSelection.length == 1) {
            this.revoke(this.multipleSelection[0])
          } else {
            // 撤单时弹出提示确认对话框
            if (window.g.FAST_SET.FAST_revoke_Dialog) {
              this.dialogVisible1 = true
            } else {
              this.fastCloseClick()
            }
          }
        } else {
          this.$message('未选委托单')
        }
        this.$emit('changIsCanle')
      }
    },
    isCorder(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    },
    tableData(val) {
      // 更新系统时间 setSystemTime
      // O:开市准备中,T:交易中,P:休市中,R:准备结算中,E:结算中,C:闭市中
      console.log('ALLSORDErtableData', val, val.length, this.marketStatusGetter)
      if (val && val.length > 0 && this.marketStatusGetter.status === 'O') {
        this.$emit('changeYMOrderType', true)
      } else {
        this.$emit('changeYMOrderType', false)
      }
    },
    marketStatusGetter() {
      // 更新系统时间 setSystemTime
      // O:开市准备中,T:交易中,P:休市中,R:准备结算中,E:结算中,C:闭市中
      if (this.tableData && this.tableData.length > 0 && this.marketStatusGetter.status === 'O') {
        this.$emit('changeYMOrderType', true)
      } else {
        this.$emit('changeYMOrderType', false)
      }
    }
  },
  mounted() {
    protocol.queryUserEntrustsNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
    this.showData()
  },
  methods: {
    fastCloseClick() {
      const that = this
      // that.fastClickSuccessNum = 0
      // that.fastClickErrorNum = 0
      that.fastClickNum = 0
      let orderList = ''
      for (const tableCellData of this.multipleSelection) {
        if (tableCellData.orderStatus == '已委托' || tableCellData.orderStatus == '部分成交') {
          if (that.fastClickNum == 0) {
            orderList = orderList + String(tableCellData.orderId)
          } else {
            orderList = orderList + ',' + String(tableCellData.orderId)
          }
          that.fastClickNum++
          // const withdrawLimitOrder = JSON.parse(JSON.stringify(protocol.withdrawLimitOrder))
          // withdrawLimitOrder.data.orderId = tableCellData.orderId
          // http.gPost(withdrawLimitOrder).then(response => {
          //   if (response.data && response.data.code == '0') {
          //     that.fastClickSuccessNum++
          //   } else {
          //     that.fastClickErrorNum++
          //   }
          //   that.isOVER()
          // })
        }
      }
      if (that.fastClickNum > 0) {
        that.fastClickNum = 0
        this.multipleSelection = []
        protocol.param_cancelFast.data.orderList = orderList
        http.gPost(protocol.param_cancelFast).then(response => {
          if (response.data && response.data.code == '0') {
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.value)
            }
            this.createPlayer()
            this.showData()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
          this.dialogVisible1 = false
        })
      }
    },
    // 准备撤单参数
    ymOrderlist() {
      let orderList = []
      for (const tableCellData of this.multipleSelection) {
        if (tableCellData.orderStatus == '已委托' || tableCellData.orderStatus == '部分成交') {
          orderList.push(tableCellData.orderId)
        }
      }
      protocol.cancelYM.data.orderIdList = orderList
    },
    restData() {
      this.search = {
        commodityCode: null,
        symbol: '全部',
        bsFlag: 'A',
        status: null,
        floatPl: null,
        commodityId: null
      }
      this.pageData.currentPage = 1
      this.showData()
    },
    searchData() {
      this.pageData.currentPage = 1
      this.showData()
    },
    selectable(row, index) {
      return row.orderStatus == '已委托' || row.orderStatus == '部分成交' // isHidden 0-否 1-是 返回false不可选
    },
    // 撤单
    revoke(obj) {
      this.sOrderId = obj.orderId
      // 撤单时弹出提示确认对话框
      if (window.g.FAST_SET.FAST_revoke_Dialog) {
        this.dialogVisible = true
      } else {
        this.revokeConfirm()
      }
    },
    // 是否撤单
    revokeOrder(done) {
      const that = this
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    revokeConfirm() {
      // const that = this
      protocol.withdrawLimitOrder.data.orderId = this.sOrderId
      http.gPost(protocol.withdrawLimitOrder).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            // 撤单成功使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_success_Dialog) {
              this.$message(response.data.message)
            }
            this.createPlayer()
            this.showData()
          } else {
            // 撤单失败使用对话框提示
            if (window.g.FAST_SET.FAST_revoke_fail_Dialog) {
              this.$message(response.data.message)
            }
          }
        }
      })
      this.dialogVisible = false
    },
    // 提示音播放
    createPlayer() {
      if (window.g.FAST_SET.FAST_Ordersuccess_Playsound) {
        const audio = new Audio(require('../../../assets/voice/1.mp3'))
        audio.play()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.ymOrderlist()
      if (val.length > 0) {
        this.showStatus = true
      } else {
        this.showData()
        this.showStatus = false
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserEntrustsNew.data.sort[0].direction = 'ASC'
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserEntrustsNew.data.sort[0].direction = 'DESC'
        this.eachSortChange(column.column.property)
      } else {
        // 取消排序,回到默认状态
        protocol.queryUserEntrustsNew.data.sort = [{
          property: 'orderId',
          direction: 'DESC'
        }]
      }
      protocol.queryUserEntrustsNew.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        http.gPost(protocol.queryUserEntrustsNew).then(response => {
          if (response.data.code != 0) {
            this.isNetWrong = true
            this.$message({ message: response.data.message })
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.OrderFrontSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
                'initQuantity': 0,
                'availableQuantity': 0,
                'quantity': 0
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserEntrustsNew.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 3: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        case 5: {
          return this.setStrClass(row.row.ocFlag, '转让', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 2) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 6) { // 委托数量
          sums[index] = that.OrderFrontSum.initQuantity
          return
        }
        if (index === 7) { // 已成交数量
          sums[index] = that.OrderFrontSum.availableQuantity
          return
        }
        if (index === 8) { // 未成交数量
          sums[index] = that.OrderFrontSum.quantity
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 订单展示
    showData() {
      protocol.queryUserEntrustsNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserEntrustsNew.data.page = this.pageData.currentPage - 1
      protocol.queryUserEntrustsNew.data.size = '' + this.pageData.pageSize
      protocol.queryUserEntrustsNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserEntrustsNew.data.commodityId = this.search.commodityId
      protocol.queryUserEntrustsNew.data.orderStatus = this.search.status != null ? [this.search.status] : [1, 4]
      protocol.queryUserEntrustsNew.data.orderType =  [1, 2, 4, 15]
      protocol.queryUserEntrustsNew.data.sort = [{
        direction: 'DESC',
        property: 'orderId'
      }]
      http.gPost(protocol.queryUserEntrustsNew).then(response => {
        if (response.data.code != 0) {
          this.isNetWrong = true
          this.$message({ message: response.data.message })
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            this.OrderFrontSum = response.data.value?.sumData?.[0] ? response.data.value.sumData[0] : {
              'initQuantity': 0,
              'availableQuantity': 0,
              'quantity': 0
            }
          }
        }
      }).catch((e) => {
        // setTimeout(() => {
        //   that.showData()
        // }, 1000)
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        if (arrIndex.cancelDealTime) {
          that.modifyTime(arrIndex, 'cancelDealTime')
        }
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
      })
      const nutableArr = this.multipleSelection
      this.tableData = arr
      const newTable = []
      for (const tableCell of nutableArr) {
        for (const newCell of arr) {
          if (tableCell.orderId === newCell.orderId) {
            newTable.push(newCell)
          }
        }
      }
      setTimeout(() => {
        that.toggleSelection(newTable)
      }, 0)
    },
    // 更改选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table.toggleRowSelection(row)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    changeCode(code) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
        if (element.commodityCode === code) {
          this.search.commodityCode = element.commodityCode
          this.search.symbol = element.symbol
          this.search.commodityId = element.symbolId
          return
        }
      })
    },
    changeSymbol(symbol) {
      const codeOption = JSON.parse(JSON.stringify(this.commodityOptions))
      codeOption.forEach(element => {
         if(element.symbol == '全部'){
           this.search.commodityId = null
           this.search.symbol = element.symbol
           this.search.commodityCode = null
           return
        }else if (element.symbol === symbol) {
          this.search.symbol = element.symbol
          this.search.commodityCode = element.commodityCode
          this.search.commodityId = element.symbolId
          return
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
/deep/ .dropColor > *{
  color: #41B37D !important;
}

/deep/ .el-table__footer-wrapper .el-table__footer{
    height: 36px !important;
}
/deep/ .el-table__row{
  height: 32px;
}
/deep/ .el-table td div{
  text-align: center;
  color: #dfdfdf;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background-color: #222324 !important;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
</style>
<style lang="scss" scoped>
//el-selecl Style
::v-deep .el-input--small .el-input__icon{
  line-height: 26px;
}
.el-select-dropdown__item.selected{
  color: #989898
}
</style>
<style lang="scss" scoped>
.rowColor{
  background-color: #161719;
}
/deep/ .el-table table tr{
   background-color: #161719;
}
.transcc_search{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin: 3px 0;
  .itemSearch{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    .title{
      width:60px;
      font-size:14px;
      // margin:0 10px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
    }
    .searchSelect{
      color: #979797;
      width:158px!important;
    }
    .decTitle{
      width:44px;
    }
    .miTitle{
      width:120px;
    }
  }
   /deep/ .el-input.is-focus .el-input__inner{
         border-color: #fff !important;
  }
  /deep/  .el-input__inner{
        height: 26px !important;
        background-color: transparent;
        border-color: rgba($color: #fff, $alpha: 0.3);
        color:#979797
      }
   /deep/.el-button{
     border:none;
     border-radius: 15px;
    padding: 5px 15px !important;
   }
  /deep/.el-button span {
    color: #fff;
  }
  .actionSearch{
    margin-left:10px;
  }

}
/deep/.el-checkbox__inner::after{
    border: 1px solid #000000;
    border-left: 0;
    border-top: 0;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #fff;
    border-color: #fff;
}
.transcc_new_NewFooter_tabs_mid{

  // min-width:1200px;
}
 .transcc_query_search {
        margin-top: 16px;
        .el-button{
          width:52px;
          height: 32px;
          background-color:transparent;
          border: 1px solid #363F66;
        }
      }
      .transcc_new_NewFooter_tabs_tabBox {
        width: 100%;
        min-width: 1200px;
        .transcc_new_NewFooter_tabs_tabBox_head {
          width: 100%;
          display: flex;
          // justify-content: space-around;
          align-items: center;
          height: 60px;
          .tab_head_item {
            width: 130px;
            margin-left: 10px;
            display: flex;
            align-items: center;
            height: 14px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.6);
            line-height: 14px;
          }
        }
        /deep/ .el-table-column--selection {
          .cell {
            padding-right: 10px;
            padding-left: 10px;
          }
        }
        .borderline {
          width: 100%;
          height: 1px;
          background: linear-gradient(
            45deg,
            rgba(94, 101, 146, 0.4) 0%,
            #464c74 53%,
            rgba(48, 53, 89, 0.4) 100%
          );
        }
      }
</style>

